module.exports = __webpack_public_path__ + "assets/557757489bf4b553444ac394550ae60c.mp3";